// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.66e89da39ec444c32ef22f216e14cef9cb1741d4.js";
};